import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

/**
 * Modal para editar as informações de um cliente.
 * @param {boolean} show - Controla a visibilidade do modal.
 * @param {Function} handleClose - Função chamada para fechar o modal.
 * @param {Function} handleSave - Função chamada para salvar as alterações.
 * @param {Object} clientData - Dados do cliente a ser editado.
 */
function EditClientModal({ show, handleClose, handleSave, clientData }) {
    const [razao, setRazao] = useState('');

    useEffect(() => {
        if (clientData) {
            setRazao(clientData.razao || '');
        }
    }, [clientData]);

    const onSave = () => {
        if (!razao.trim()) {
            alert('Por favor preencha o campo "Razão social".');
            return;
        }
        handleSave(clientData.id, razao);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar Cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="razao">
                        <Form.Label>Razão Social</Form.Label>
                        <Form.Control 
                            type="text" 
                            placeholder="Digite a razão social" 
                            value={razao}
                            onChange={(e) => setRazao(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditClientModal;
